import pgToolTip from './pgToolTip.vue'
export default pgToolTip
